import { memo } from 'react';
import { Range, RangeKeyDict } from 'react-date-range';

import RadioButton from '@components/radio-button/RadioButton';
import { IdLabelValue } from '@types';

import Checkbox from '../checkbox/Checkbox';
import CalendarModal from './CalendarModal';

interface OptionItemProps {
  item: IdLabelValue;
  isSingleSelect: boolean;
  isSelected: boolean;
  onToggle: (item: IdLabelValue, checked: boolean) => void;
  dateRange: Range;
  onDateChange: (obj: RangeKeyDict) => void;
}

const OptionItem = memo(
  ({
    item,
    isSingleSelect,
    isSelected,
    onToggle,
    dateRange,
    onDateChange
  }: OptionItemProps) => {
    if (isSingleSelect) {
      return (
        <div className="px-2 py-2.5">
          <RadioButton
            isSelected={isSelected}
            onChange={(e) => onToggle(item, e.target.checked)}
            label={item.label}
            value={item.value}
            iconStyle="!size-4"
            labelStyle="!ml-1.5 !text-sm !font-normal !leading-none !tracking-normal !text-textblack"
          />
          {isSelected && item?.type === 'date' && (
            <CalendarModal
              handleDateChange={onDateChange}
              selectedDate={dateRange}
            />
          )}
        </div>
      );
    }
    return (
      <div className="px-2 py-2.5">
        <Checkbox
          handleChange={(e) => onToggle(item, e.target.checked)}
          label={item.label}
          isChecked={isSelected}
          checkboxStyle="self-start mt-0.5 shrink-0"
          labelStyle="!text-sm !font-normal !leading-none !tracking-normal !text-textblack break-all"
        />
      </div>
    );
  }
);

export default OptionItem;
